module.exports = __webpack_public_path__ + "static/media/wa.669466c1.png";